import React from 'react';

const markup = String.raw`<div class="card" id="vendPaymentCard">
<div class="card-head"><p class="card-title">Payment center</p></div>
<div class="tile-row inline-style-53"></div>
</div>`;

export default function PaymentCenterCard() {
  return <div className="raw-fragment" dangerouslySetInnerHTML={{ __html: markup }} />;
}
